<template>
  <div class="form-group">
    <div class="d-flex flex-column justify-content-center align-items-center h-100 px-3 text-left">
      <span v-if="loading" class="inline-loader"></span>
      <error-banner v-if="error" :message="error" class="my-auto mx-auto" />
      <div v-if="paymentLink" class="w-100">
        <h4><strong>Payment Instructions</strong></h4>
        <ul class="mb-3">
          <li>Click the <strong>"Open"</strong> button below to go to the secure payment page.</li>
          <li>Enter your card details, review, and confirm payment.</li>
        </ul>
        <h4><strong>After Payment</strong></h4>
        <ul class="mb-3">
          <li>Go back to this page and click the <strong>"Back"</strong> button.</li>
          <li>If you encounter any issues, please contact support.</li>
        </ul>
        <button class="btn btn-primary w-100" @click="openPaymentLink">Open</button>
        <button class="btn btn-outline-secondary w-100 mt-2" @click="$emit('completed')">Back</button>
      </div>
      <div v-else-if="!paymentLink && !loading">
        <button class="fa mw-100 mt-2" type="button" @click="$emit('cancelled')">
          <span class="fa-stack fa-primary">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fas fa-arrow-left fa-stack-1x fa-inverse"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { PaymentApi } from '@/services/PaymentApi'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue'

export default {
  name: 'LopayWidget',
  props: {
    checkout: Object,
    reference: String
  },
  data () {
    return {
      error: '',
      loading: false,
      paymentLink: null
    }
  },
  methods: {
    tryGetPaymentLink () {
      const self = this
      self.loading = true
      self.error = ''
      PaymentApi.get('ClientLopay/' + self.reference + '/PaymentLink?' + new URLSearchParams({ providerReference: self.checkout.providerReference }))
        .then((response) => { self.paymentLink = response.data.url })
        .catch(error => { self.error = ErrorHelper.getError(error) })
        .finally(() => { self.loading = false })
    },
    openPaymentLink () {
      if (this.paymentLink) {
        window.open(this.paymentLink, '_blank')
      }
    }
  },
  created () {
    this.tryGetPaymentLink()
  },
  components: {
    'error-banner': ErrorBanner
  }
}
</script>
